import * as React from "react";
import {
  stickyContainer,
  header,
  row,
  searchWrapper,
  stripeColor,
} from "./SearchBar.module.scss";
import Sticky from "react-sticky-el";
import Row from "../../global/Row/Row";
import { Container } from "react-bootstrap";
import { useScrollVisibility } from "../../../context/scrollVisibilityContext";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const StickyContainer: React.FC<any> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  const { isVisible } = useScrollVisibility();

  return isMobileOnly && !isVisible ? (
    <div className={stickyContainer}>{props.children}</div>
  ) : (
    <Sticky className={stickyContainer} positionRecheckInterval={1}>
      {props.children}
    </Sticky>
  );
};
export const Header: React.FC<any> = (props) => {
  return (
    <React.Fragment>
      <Container className={`${header} ${props.className}`} ref={props.compRef}>
        {props.children}
      </Container>
    </React.Fragment>
  );
};
export const StyledRow: React.FC<any> = (props) => {
  return <Row className={row}>{props.children}</Row>;
};
export const SearchWrapper: React.FC<any> = (props) => {
  return <div className={searchWrapper}>{props.children}</div>;
};

export const BrandStripe = (props: {
  children: any;
  brandStripeColor: string;
}): JSX.Element => {
  return (
    <div
      className={stripeColor}
      style={{
        backgroundColor: props.brandStripeColor,
      }}
    >
      {props.children}
    </div>
  );
};
